import VerifyEmailButton from "@/components/templates/Signup/verify-email-button";

type UserVerifyProps = {
  resolution: Resolution;
};

const UserVerify = ({ resolution }: UserVerifyProps) => {
  const {
    locale,
    slugs: [, customerId],
  } = resolution;

  return (
    <section className="mx-auto mt-14 flex w-full max-w-[672px] items-center justify-center max-sm:my-[156px]">
      <VerifyEmailButton locale={locale} customerId={customerId} />
    </section>
  );
};

export default UserVerify;
